import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/page.tsx");
